<template>
  <div
    class="as-statistics"
    :class="{
      'as-scrolling as-scrolling__result-popup': !isHomePage,
      'as-home-scrollable-content': isHomePage,
    }"
  >
    <div class="as-statistics__content">
      <div
        class="as-statistics__line"
        v-for="(stat, key) in processedStats"
        :key="key"
      >
        <span
          class="as-statistics__value as-statistics__value--home"
          :class="stat.winHome"
          >{{ stat.home }}</span
        >
        <span
          class="as-statistics__bar-wrapper as-statistics__bar-wrapper--home"
          :class="stat.winHome"
        >
          <span
            class="as-statistics__bar as-statistics__bar--home"
            :style="{ width: stat.showHomePre || 50 }"
          ></span>
        </span>
        <span class="as-statistics__title">{{ stat.type }}</span>
        <span
          class="as-statistics__bar-wrapper as-statistics__bar-wrapper--away"
          :class="stat.winAway"
        >
          <span
            class="as-statistics__bar as-statistics__bar--away"
            :style="{ width: stat.showAwayPre || 40 }"
          ></span>
        </span>
        <span
          class="as-statistics__value as-statistics__value--away"
          :class="stat.winAway"
          >{{ stat.away }}</span
        >
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, defineProps, PropType, inject, ref, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/badminton";
import { getProcessedStats } from "~src/helpers/volleyball/index";
import StatsEnum from "~src/enums/badminton/StatsEnum";

interface IProps {
  statistics: IStatistics;
  match: IMatch;
  isHomePage: boolean;
  isDefault: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
  isDefault: false,
});

interface IProcessedStat {
  type?: string;
  home?: string | number;
  away?: string | number;
  showHomePre?: string;
  showAwayPre?: string;
  winHome?: string;
  winAway?: string;
}

const processedStats = computed<IProcessedStat[]>(() => {
  let data = getProcessedStats(
    props.match,
    props.statistics,
    props.isDefault
  );
  if (data[0].home !== '0' && data[0].away != '0') {
    data = data.filter((stat: any) => {
      return stat.home !== '0' || stat.away !== '0';
    });
  }
  data.forEach((item: any, index: number) => {
    let _winHome = "";
    let _winAway = "";
    let _home = data[index]["home"];
    let _away = data[index]["away"];
    let _percentHome = _home;
    let _percentAway = _away;
    if (StatsEnum.showPreKeys.includes(item.key)) {
      if (typeof _home === "string") {
        let [_success, _total] = _home.split("/").map(Number);
        _percentHome = ((_success / _total) * 100).toFixed(1);
        data[index]["showHomePre"] = `${_percentHome}%`;
      }

      if (typeof _away === "string") {
        let [__success, __total] = _away.split("/").map(Number);
        _percentAway = ((__success / __total) * 100).toFixed(1);
        data[index]["showAwayPre"] = `${_percentAway}%`;
      }
    }

    if (StatsEnum.percentKeys.includes(item.key)) {
      _percentHome = (Number(_home) * 100).toFixed(1);
      _percentAway = (Number(_away) * 100).toFixed(1);
      data[index]["home"] = `${_percentHome}%`;
      data[index]["away"] = `${_percentAway}%`;
      data[index]["showHomePre"] = `${_percentHome}%`;
      data[index]["showAwayPre"] = `${_percentAway}%`;
    }

    _winHome = _percentHome > _percentAway ? "as-statistics__home-win" : "";
    _winAway = _percentHome < _percentAway ? "as-statistics__away-win" : "";

    data[index]["winHome"] = _winHome;
    data[index]["winAway"] = _winAway;
  });

  return data;
});
</script>
